import React from "react";
type LogoMarkProps = {
  className?: string;
};

/** Retro setting-sun mark: a solid disc whose lower half breaks into thinning stripes. */
export function LogoMark({
  className = ""
}: LogoMarkProps) {
  return <svg viewBox="0 0 40 40" className={className} aria-hidden="true" focusable="false" data-id="element-213" data-mp="2ajyd8vjdgj3y">
      <defs data-id="element-214" data-mp="25ry6aj4vwpxv">
        <clipPath id="logo-sun" data-id="element-215" data-mp="25rep54n265kw">
          <circle cx="20" cy="20" r="18" data-id="element-216" data-mp="25q3mx999h5vw" />
        </clipPath>
      </defs>
      <g clipPath="url(#logo-sun)" fill="currentColor" data-id="element-217" data-mp="2kfjakgdhwv7d">
        <rect x="0" y="0" width="40" height="20" className="fill-mustard" data-id="element-218" data-mp="2fi9lx2xxknkl" />
        <rect x="0" y="22" width="40" height="4.5" data-id="element-219" data-mp="2fkdonhk3fgja" />
        <rect x="0" y="28.5" width="40" height="3.5" data-id="element-220" data-mp="2tgr4yncw5bw6" />
        <rect x="0" y="34" width="40" height="2.5" data-id="element-221" data-mp="2pg7axsnm6oe9" />
        <rect x="0" y="38.25" width="40" height="1.75" data-id="element-222" data-mp="2phibzkpodi1o" />
      </g>
    </svg>;
}